import axios from 'axios';

const getBaseUrl = () => {
    const host = window.location.hostname;
    const protocol = window.location.protocol;
    if (host === "localhost") {
        return `http://${host}:8080`
    } else if (protocol === 'https:') {
        return `https://${host}`
    }
    return `http://${host}`
};

const axiosConfig = axios.create({
    baseURL: getBaseUrl(),
    timeout: 10000
});

axiosConfig.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        if (error.response) {
            console.log("client received an error response (5xx, 4xx)")
        } else if (error.request) {
            console.log("client never received a response, or request never left")
        } else {
            console.log("network error")
        }
        return Promise.reject(error.response);
    }
)

export default axiosConfig;